const postFixWord = (word: string, postfix = 's') => `${word}${postfix}`;

export default postFixWord;
